import { IPagination } from 'app/types/common';

export interface ICompetitionsState {
  readonly competitionsById?: any;
  readonly competitionIds?: string[];
  readonly hasSaved?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly showAddCompetition?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationCompetitionIds?: string[];
  readonly currentCompetitionId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface ICompetitionsSelector extends ICompetitionsState {
  readonly currentCompetition?: any;
  readonly currentFormCompetition?: any;
  readonly competitionsFilteredByTagInSelectFormat?: any;
  readonly competitionsByIdInSelectFormat?: any;
  readonly competitionsFilteredByOrganisationInSelectFormat?: any;
}

export enum CompetitionsActionTypes {
  GET_ALL_COMPETITIONS_REQUESTED = 'redux-app/competitions/GET_ALL_COMPETITIONS_REQUESTED',
  GET_ALL_COMPETITIONS_PENDING = 'redux-app/competitions/GET_ALL_COMPETITIONS_PENDING',
  GET_ALL_COMPETITIONS_SUCCESS = 'redux-app/competitions/GET_ALL_COMPETITIONS_SUCCESS',
  GET_ALL_COMPETITIONS_FAIL = 'redux-app/competitions/GET_ALL_COMPETITIONS_FAIL',
  GET_COMPETITION_REQUESTED = 'redux-app/competitions/GET_COMPETITION_REQUESTED',
  GET_COMPETITION_PENDING = 'redux-app/competitions/GET_COMPETITION_PENDING',
  GET_COMPETITION_SUCCESS = 'redux-app/competitions/GET_COMPETITION_SUCCESS',
  GET_COMPETITION_FAIL = 'redux-app/competitions/GET_COMPETITION_FAIL',
  UPDATE_COMPETITION_REQUESTED = 'redux-app/competitions/UPDATE_COMPETITION_REQUESTED',
  UPDATE_COMPETITION_PENDING = 'redux-app/competitions/UPDATE_COMPETITION_PENDING',
  UPDATE_COMPETITION_SUCCESS = 'redux-app/competitions/UPDATE_COMPETITION_SUCCESS',
  UPDATE_COMPETITION_FAIL = 'redux-app/competitions/UPDATE_COMPETITION_FAIL',
  CREATE_COMPETITION_REQUESTED = 'redux-app/competitions/CREATE_COMPETITION_REQUESTED',
  CREATE_COMPETITION_PENDING = 'redux-app/competitions/CREATE_COMPETITION_PENDING',
  CREATE_COMPETITION_SUCCESS = 'redux-app/competitions/CREATE_COMPETITION_SUCCESS',
  CREATE_COMPETITION_FAIL = 'redux-app/competitions/CREATE_COMPETITION_FAIL',
  DELETE_COMPETITION_REQUESTED = 'redux-app/competitions/DELETE_COMPETITION_REQUESTED',
  DELETE_COMPETITION_PENDING = 'redux-app/competitions/DELETE_COMPETITION_PENDING',
  DELETE_COMPETITION_SUCCESS = 'redux-app/competitions/DELETE_COMPETITION_SUCCESS',
  DELETE_COMPETITION_FAIL = 'redux-app/competitions/DELETE_COMPETITION_FAIL',
  SELECT_COMPETITION_REQUESTED = 'redux-app/competitions/SELECT_COMPETITION_REQUESTED',
}

export default null;
